export default "__VITE_ASSET__BJsm9UaW__"